import * as actionTypes from './actionTypes';
import { getContentModelId } from '../selectors/baseContentModelSelectors';
import { getSelectedItemId } from '../selectors/selectionSelectors';
// @ts-expect-error not yet migrated
import { clearSelectedItem } from './selectionActions';
import { getCurrentGridLayoutSectionToAddTo } from '../selectors/sectionsSelectors';
import { fetchGridLayoutByDndAreaName } from '../../api/GridLayoutsApi';
import { fetchLayoutGenerationTask, startLayoutGenerationTask } from '../../api/GridsLayoutGenerationApi';
export const setNodeStyles = (nodeId, gridLayoutId, isEditorProvidedModuleStyles, activeBreakpoint, styles) => ({
  type: actionTypes.GRID_LAYOUTS_SET_NODE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    isEditorProvidedModuleStyles,
    activeBreakpoint,
    styles
  }
});
export const setOldModuleStyles = (nodeId, gridLayoutId, styles) => ({
  type: actionTypes.GRID_SET_OLD_MODULE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    styles
  }
});
export const setContainerLayoutType = (nodeId, gridLayoutId, activeBreakpoint, layoutType) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_NODE_LAYOUT,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    layoutType
  }
});
export const updateGridTableDefinition = (nodeId, gridLayoutId, activeBreakpoint, newRows, newColumns) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_TABLE_DEFINITION,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    newRows,
    newColumns
  }
});
export const cloneNodeAndInsertAfterOriginalInGridLayout = (gridLayoutId, nodeId) => dispatch => {
  dispatch({
    type: actionTypes.GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteContainerFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_CONTAINER_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteSectionFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_SECTION_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const insertBlankSectionInGridLayout = newSectionLayout => (dispatch, getState) => {
  const state = getState();
  const currentGridLayoutSectionToAddTo = getCurrentGridLayoutSectionToAddTo(state);
  if (currentGridLayoutSectionToAddTo) {
    dispatch({
      type: actionTypes.GRID_LAYOUTS_INSERT_BLANK_SECTION,
      payload: {
        gridLayoutId: currentGridLayoutSectionToAddTo.gridLayoutId,
        beforeNodeId: currentGridLayoutSectionToAddTo.beforeNodeId,
        afterNodeId: currentGridLayoutSectionToAddTo.afterNodeId,
        newSectionLayout
      }
    });
  } else {
    console.error('No current grid layout section to add to');
  }
};
export const deleteModuleFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItem = getSelectedItemId(state);
  if (selectedItem === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_MODULE_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
const pollForLayoutGenerationTask = (gridLayoutId, taskId) => async dispatch => {
  const pollTask = async () => {
    try {
      const {
        taskStatus,
        agentMessages
      } = await fetchLayoutGenerationTask(taskId);
      switch (taskStatus) {
        case 'COMPLETE':
          dispatch({
            type: actionTypes.GRID_LAYOUTS_GENERATION_SUCCEEDED,
            payload: {
              gridLayoutId,
              status: 'COMPLETE',
              agentMessages
            }
          });

          //  TODO: pull returned GRID_LAYOUT_CHANGE message JSON and incoporate into target gridLayout

          return;
        // Stop polling
        case 'FAILED':
          dispatch({
            type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
            payload: {
              gridLayoutId,
              status: 'FAILED'
            }
          });
          return;
        // Stop polling
        default:
          // Continue polling after 1 second delay
          setTimeout(() => {
            void pollTask();
          }, 1000);
          break;
      }
    } catch (e) {
      console.error(e);
      dispatch({
        type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
        payload: {
          gridLayoutId,
          status: 'FAILED'
        }
      });
      // Stop polling on error
      return;
    }
  };
  await pollTask();
};
export const generateGridLayout = (gridLayoutId, nodeId) => async (dispatch, getState) => {
  const state = getState();
  const contentId = getContentModelId(state);
  let targetGridLayoutWithMeta;
  let newTaskId;
  try {
    var _targetGridLayoutWith;
    // Note: this is a known workaround around E1.0 vs E2.0 and a product of RPC and non-RPC services (`combined-edit-data` vs `grid-buffers`)
    // This data is in redux, but stored in a shape that the layout gen RPC does not expect.
    // for the lifespan of E1.0, it's probably easiest to fetch it directly. More context in: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/20538#discussion_r4971878
    const {
      gridLayout: fetchedGridLayout
    } = await fetchGridLayoutByDndAreaName(contentId, gridLayoutId);
    targetGridLayoutWithMeta = fetchedGridLayout;
    if ((_targetGridLayoutWith = targetGridLayoutWithMeta) !== null && _targetGridLayoutWith !== void 0 && _targetGridLayoutWith.gridLayout) {
      const {
        taskId
      } = await startLayoutGenerationTask({
        task: 'Rearrange modules into a new layout while keeping all the same content',
        contentId,
        focusedNodeId: nodeId,
        gridLayout: targetGridLayoutWithMeta.gridLayout
      });
      if (taskId) {
        newTaskId = taskId;
      }
    }
    if (newTaskId) {
      dispatch({
        type: actionTypes.GRID_LAYOUTS_GENERATION_STARTED,
        payload: {
          gridLayoutId,
          contentId,
          nodeId,
          taskId: newTaskId
        }
      });
      await dispatch(pollForLayoutGenerationTask(gridLayoutId, newTaskId));
    }
  } catch (e) {
    console.error(e);
    dispatch({
      type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
      payload: {
        gridLayoutId,
        contentId
      }
    });
  }
};